import { appSettings } from 'app/appSettings';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { EInvoice, EInvoiceFromMW, EInvoicesState } from '../../interfaces/e-invoice.interface';
import * as actions from './e-invoice.actions';

const initialState: EInvoicesState = {
  loading: false,
  loaded: false,
  downloading: false,
  items: [],
  totalItems: null,
  filter: {
    type: '',
    pageSize: appSettings.PAGE_SIZE,
    pageNr: 1,
    sortField: 'invoiceDate',
    sortAscending: false,
    soldTo: 'all',
    customerIds: [],
    invoiceDateFrom: null,
    invoiceDateTo: null,
    invoiceNumber: null,
    netAmountFrom: null,
    netAmountTo: null,
  },
};

const mwToFeMapper = (invoiceFromMW: EInvoiceFromMW, customers: Customer[]): EInvoice => {
  const soldTo = customers.find(c => c.id === invoiceFromMW.financialActor);
  return {
    // If different, can be mapped here
    ...invoiceFromMW,
    soldToLabel: soldTo ? `${soldTo.id} ${soldTo.name}` : `${invoiceFromMW.financialActor} ${invoiceFromMW.financialActorName}`,
  };
};

function queryInvoicesStart(state: EInvoicesState, action: actions.QueryEInvoicesStartAction): EInvoicesState {
  return Object.assign({}, state, {
    loaded: false,
    loading: true,
    filter: action.payload.filter,
    items: [],
    totalItems: null,
  });
}

function queryInvoicesSuccess(state: EInvoicesState, action: actions.QueryEInvoicesSuccessAction): EInvoicesState {
  return Object.assign({}, state, {
    loading: false,
    loaded: true,
    items: action.payload.invoices.items.map(i => mwToFeMapper(i, action.payload.customers)),
    totalItems: action.payload.invoices.totalItems,
  });
}

function invoiceDownload(state: EInvoicesState, action: actions.EInvoiceDownloadPdfAction): EInvoicesState {
  return Object.assign({}, state, { downloading: true });
}

function invoiceDownloadSuccess(state: EInvoicesState, action: actions.EInvoiceDownloadPdfSuccessAction): EInvoicesState {
  return Object.assign({}, state, { downloading: false });
}

function invoiceDownloadFail(state: EInvoicesState, action: actions.EInvoiceDownloadPdfFailAction): EInvoicesState {
  return Object.assign({}, state, { downloading: false });
}

function invoiceDownloadList(state: EInvoicesState, action: actions.EInvoiceDownloadListAction): EInvoicesState {
  return Object.assign({}, state, { downloading: true });
}

function invoiceDownloadListSuccess(state: EInvoicesState, action: actions.EInvoiceDownloadListSuccessAction): EInvoicesState {
  return Object.assign({}, state, { downloading: false });
}

function invoiceDownloadListFail(state: EInvoicesState, action: actions.EInvoiceDownloadListFailAction): EInvoicesState {
  return Object.assign({}, state, { downloading: false });
}

function clearInvoicesFilter(state: EInvoicesState): EInvoicesState {
  return {
    ...initialState,
  };
}

export function reducer(state = initialState, action: actions.Actions): EInvoicesState {
  let newState = state;
  switch (action.type) {
    case actions.QUERY_E_INVOICES_START:
      newState = queryInvoicesStart(state, action);
      break;
    case actions.QUERY_E_INVOICES_SUCCESS:
      newState = queryInvoicesSuccess(state, action);
      break;
    case actions.CLEAR_E_INVOICES_FILTER:
    case actions.QUERY_E_INVOICES_FAIL:
      newState = clearInvoicesFilter(state);
      break;
    case actions.E_INVOICE_DOWNLOAD_PDF: {
      newState = invoiceDownload(state, action);
      break;
    }
    case actions.E_INVOICE_DOWNLOAD_PDF_SUCCESS: {
      newState = invoiceDownloadSuccess(state, action);
      break;
    }
    case actions.E_INVOICE_DOWNLOAD_PDF_FAIL: {
      newState = invoiceDownloadFail(state, action);
      break;
    }
    case actions.E_INVOICE_DOWNLOAD_LIST: {
      newState = invoiceDownloadList(state, action);
      break;
    }
    case actions.E_INVOICE_DOWNLOAD_LIST_SUCCESS: {
      newState = invoiceDownloadListSuccess(state, action);
      break;
    }
    case actions.E_INVOICE_DOWNLOAD_LIST_FAIL: {
      newState = invoiceDownloadListFail(state, action);
      break;
    }
  }

  return newState;
}
